import {
  Spin,
} from "antd";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from 'primereact/columngroup';
import { DataTable } from "primereact/datatable";
import { Row } from 'primereact/row';
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  getUsersByRoles,
} from "../../apis/SettingApis";
import {
  UPDATE_ASSIGNING_PAGE,
  USER_TYPE_QUALITY_CHECKER,
} from "../../utils/constants";
import UpdateQualityCheckerAutoAssign from "./dialog/UpdateQualityCheckerAutoAssign";

const QualityCheckerAutoAssign = () => {
  const [users, setUsers] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visibleQCerAutoAssignDialog, setVisibleQCAutoAssignDialog] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const { currentUser = {} } = useSelector(({ app }) => app);

  const dt = useRef(null);
  const toast = useRef(null);

  const fetchPermissions = () => {
    const uniquePermissions = {};
    if (currentUser && currentUser.roles) {
      currentUser.roles.forEach((role) => {
        role.permissions.forEach(
          (permission) => (uniquePermissions[permission.id] = permission)
        );
      });
      setPermissions(Object.values(uniquePermissions));
    }
  };

  const changeVisibleQCerAutoAssignDialog = (visible) => {
    setVisibleQCAutoAssignDialog(visible);
    fetchUsers();
  }

  useEffect(() => {
    fetchPermissions();
  }, [currentUser]);

  const fetchUsers = () => {
    setApiLoading(true);
    getUsersByRoles(USER_TYPE_QUALITY_CHECKER, -1)
      .then((response) => {
        if (response.status === 200) {
          response.data = response.data.sort((u1, u2) => {
            return u1.priority - u2.priority;
          });
          setUsers(response.data);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
    return false;
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    fetchUsers();
  }, []);

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Order who to assign first" rowSpan={2} />
        <Column header="User Name" rowSpan={2} />
        <Column header="Name" rowSpan={2} />
        <Column 
          header={<>Remaining Availability<br /><span>(Capacity per Day − Assigned)</span></>} 
          rowSpan={2} 
        />
        <Column 
          header="Assigned Availability" 
          rowSpan={2} 
        />
        <Column header="Num project assigned" rowSpan={2} />
        <Column header="Max Level Of QC" rowSpan={2} />
        <Column header="Action" rowSpan={2} />
      </Row>
    </ColumnGroup>
  );
  

  return (
    <React.Fragment>
      <div className="user-custom-style">
        <Toast ref={toast} />
        <div>
          <Spin spinning={apiLoading}>
            <Toolbar
              className="mb-4"
              left={() => {
                return (
                  <React.Fragment>
                    <div>
                      <h3 className="m-0">Quality Checker Users</h3>
                    </div>
                  </React.Fragment>
                );
              }}
              right={() => {
                return (
                  <React.Fragment>
                  </React.Fragment>
                );
              }}
            ></Toolbar>
            <DataTable
              ref={dt}
              value={users}
              dataKey="id"
              responsiveLayout="scroll"
              headerColumnGroup={headerGroup}
            >
              <Column field="priority" header="Priority" />
              <Column field="username" header="Username" />
              <Column field="name" header="Name" />
              <Column field="numProjectCanAssign" header="Availability" />
              <Column field="totalWeightAssigned" header="Assigned Availability" />
              <Column field="numProjectAssigned" header="Num project assigned" />
              <Column field="level" header="Level/ Type" />
              <Column
                field="action"
                header="Action"
                body={(record) => {
                  return (
                    <React.Fragment>
                      <div className="flex justify-content-center">
                        {permissions.map((permission) => {
                          return permission.name === UPDATE_ASSIGNING_PAGE ? (
                            <div>
                              <Button
                                style={{
                                  backgroundColor: "#037EEA",
                                  borderColor: "#037EEA",
                                }}
                                icon={"pi pi-pencil"}
                                label="Edit"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setSelectedUser(record);
                                  setVisibleQCAutoAssignDialog(true);
                                }}
                              />
                            </div>
                          ) : (
                            ""
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                }}
              />
            </DataTable>
            <div>
              <br />
              <p><strong>Example:</strong></p>
              <ul>
                <li>Project Levels: A = 1, B = 2, C = 3, D = 4, E = 5</li>
                <li><strong>User A:</strong></li>
                <ul>
                  <li>Capacity per day: <strong>10</strong></li>
                  <li>Assigned Projects: 2 × A, 1 × B, 1 × C</li>
                  <li>Assigned Availability: 2 × 1 + 2 + 3 = <strong>7</strong></li>
                  <li>Remaining Availability: 10 − 7 = <strong>3</strong></li>
                  <li>Number of Projects Assigned: 2 + 1 + 1 = <strong>4</strong></li>
                </ul>
              </ul>
            </div>

          </Spin>
        </div>

      </div>
      <UpdateQualityCheckerAutoAssign
        user={selectedUser}
        visible={visibleQCerAutoAssignDialog}
        setVisible={changeVisibleQCerAutoAssignDialog}>
      </UpdateQualityCheckerAutoAssign>
    </React.Fragment>
  );
};

export default QualityCheckerAutoAssign;
